import { ReactNode, FC } from 'react'

import { useAuthentication } from '@shared/contexts/authenticationContext'

import { User, UserType } from '@legacy/models/WhoAmI'

import { passesUserType, passesRoles } from './utilities'

export type ProtectedChildrenProps = {
  roles?: string[]
  userTypes?: UserType[]
  renderUnauthorized?: ReactNode | undefined
}

const ProtectedChildren: FC<React.PropsWithChildren<ProtectedChildrenProps>> = ({
  children,
  roles,
  userTypes,
  renderUnauthorized,
}) => {
  const { whoAmI } = useAuthentication()

  if (whoAmI && whoAmI.user) {
    const user = whoAmI?.user as unknown as User

    if (passesUserType(userTypes, user) && passesRoles(roles, user)) {
      return <>{children}</>
    }
  }

  if (renderUnauthorized) return <>{renderUnauthorized}</>

  return null
}

export default ProtectedChildren
